import { IGetEventListRes } from '@reolink-cloud/interface';
import { IStores, stores as defaultStores } from './stores';

/**
 * 把事件列表响应同步到加密元信息 IDB。
 *
 * 旧实现仅在 SW 内执行；当 SW 不可用（无痕、被 unregister、未激活等）时，
 * 主线程降级路径 `secureMedia` 会读到空 IDB → 没鉴权头 → 请求失败。
 * 抽出为纯函数后主线程也可直接调用，写入同一份 IDB（`shared/stores`），
 * 让 SW 是否可用不再影响业务流程。
 */
export const applyEventListResToStores = async (
    eventRes: IGetEventListRes,
    storesInstance: IStores = defaultStores
): Promise<void> => {

    const writes: Array<Promise<void>> = [];

    writes.push(
        storesInstance.eventExtraInfo.get().then( info => {

            return storesInstance.eventExtraInfo.set({
                ck: eventRes.ck ?? '',
                requestArgs: info?.requestArgs ?? {}
            });

        })
    );

    for ( const [key, value] of Object.entries( eventRes.encryptKeys ?? {})) {

        writes.push( storesInstance.encryptDetail.set( key, value ));

    }

    for ( const eventItem of eventRes.items ) {

        for ( const galleryItem of eventItem.items ) {

            for ( const file of galleryItem.files ) {

                if ( galleryItem.encrypt ) {

                    writes.push( storesInstance.encryptKey.set( file.url, galleryItem.encrypt ));

                }

                if ( eventRes.ck ) {

                    writes.push( storesInstance.accessKey.set(
                        file.url,
                        { id: galleryItem.id, ck: eventRes.ck }
                    ));

                }

            }

        }

    }

    await Promise.all( writes );

};

/**
 * 把当前查询参数写入 `eventExtraInfo.requestArgs`，供 SW 在网络错误上报时附带上下文。
 * 与 {@link applyEventListResToStores} 一样可在两端复用。
 */
export const applyRequestArgsToStores = async (
    requestArgs: Record<string, unknown>,
    storesInstance: IStores = defaultStores
): Promise<void> => {

    const info = await storesInstance.eventExtraInfo.get();
    await storesInstance.eventExtraInfo.set({
        ck: info?.ck ?? '',
        requestArgs
    });

};
